import { AppStats } from "../actions";

const initialState = {
  invitations: { docs: [], totalPages: 0 },
  coInvitations: { docs: [], totalPages: 0 },
  stats: {},
};

const handleNewDocs = (state, payload, key) => {
  if (payload?.page === 1) return payload.docs;
  const _docs = payload.docs.filter(
    (newDoc) => !state[key].docs.find((oldDoc) => newDoc._id === oldDoc._id)
  );
  return [...state?.[key]?.docs, ..._docs];
};

const app = (state = initialState, { type, payload, key } = {}) => {
  switch (type) {
    case AppStats.GET_STATS_SUCCESS:
      return {
        ...state,
        stats: { ...payload },
      };

    case AppStats.GET_MUTUAL_MANAGEMENT_SUCCESS:
      return {
        ...state,
        invitations: {
          docs: handleNewDocs(state, payload, key),
          totalPages: payload.totalPages,
        },
      };

    case AppStats.CO_MANAGEMENT_STATUS_SUCCESS:
      return {
        ...state,
        coInvitations: {
          docs: handleNewDocs(state, payload, key),
          totalPages: payload.totalPages,
        },
      };

    default:
      return state;
  }
};

export default app;
